import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { getSectionRootFromVariantPickerBlock, getSectionScopedRoot } from '@theme/utilities';
import { morph } from '@theme/morph';

class ProductInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else {
      const incoming = event.detail.data.productId;
      const mine = this.dataset.productId;
      if (
        incoming != null &&
        String(incoming) !== '' &&
        mine != null &&
        String(mine) !== '' &&
        String(incoming) !== String(mine)
      ) {
        return;
      }
    }

    const section = this.closest('.shopify-section');
    const doc = event.detail.data.html;
    const scope =
      getSectionRootFromVariantPickerBlock(doc, event.detail.data.variantPickerBlockId) ||
      getSectionScopedRoot(doc, section) ||
      doc;
    const newInventory = scope.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
